/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { smallerDependencies } from './dependenciesSmaller.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMin } from '../../factoriesAny.js';
export var minDependencies = {
  smallerDependencies: smallerDependencies,
  typedDependencies: typedDependencies,
  createMin: createMin
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMin.generated.js
// module id = 1454
// module chunks = 0